"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DomainError = void 0;
/**
 * DomainError — base class for all application-level errors.
 *
 * Every error thrown from `shared/` or from domain services in `server/`
 * must extend this class.  NestJS HttpException is acceptable at the
 * controller boundary only.
 */
class DomainError extends Error {
    code;
    cause;
    constructor(message, code, cause) {
        super(message);
        this.name = this.constructor.name;
        this.code = code;
        this.cause = cause;
        // Restore prototype chain (required when extending built-in Error in ES5 targets).
        Object.setPrototypeOf(this, new.target.prototype);
    }
}
exports.DomainError = DomainError;
//# sourceMappingURL=domain-error.js.map